import React from "react";

class PriceMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lessThan: (props.values && props.values.lessThan) || "",
            greaterThan: (props.values && props.values.greaterThan) || ""
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.values !== this.props.values) {
            this.setState({
                lessThan: (this.props.values && this.props.values.lessThan) || "",
                greaterThan: (this.props.values && this.props.values.greaterThan) || ""
            });
        }
    }

    handleChange = (field, value) => {
        var cleaned = value.replace(/[^0-9.]/g, "");
        this.setState({ [field]: cleaned });
    };

    handleSubmit = () => {
        var vals = {};
        var hasValue = false;
        if (this.state.greaterThan !== "") {
            vals.greaterThan = parseFloat(this.state.greaterThan);
            hasValue = true;
        }
        if (this.state.lessThan !== "") {
            vals.lessThan = parseFloat(this.state.lessThan);
            hasValue = true;
        }
        if (typeof this.props.onApply === "function") {
            this.props.onApply(hasValue ? vals : {});
        }
        if (typeof this.props.close === "function") {
            this.props.close();
        }
    };

    render() {
        return (
            <div className="ff-price-menu">
                <div className="ff-price-row">
                    <span className="ff-price-label">Greater than</span>
                    <span className="ff-price-currency">$</span>
                    <input
                        type="text"
                        className="ff-price-input"
                        placeholder="Min"
                        value={this.state.greaterThan}
                        onChange={(e) => this.handleChange("greaterThan", e.target.value)}
                    />
                </div>
                <div className="ff-price-row">
                    <span className="ff-price-label">Less than</span>
                    <span className="ff-price-currency">$</span>
                    <input
                        type="text"
                        className="ff-price-input"
                        placeholder="Max"
                        value={this.state.lessThan}
                        onChange={(e) => this.handleChange("lessThan", e.target.value)}
                    />
                </div>
                <button
                    type="button"
                    className="ff-price-submit"
                    onClick={this.handleSubmit}
                >
                    Search By Price
                </button>
            </div>
        );
    }
}

export default PriceMenu;
